import React, { createContext, useContext, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

const LanguageContext = createContext({ lang: 'fr', setLang: () => {} });

export const LanguageProvider = ({ children }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const lang = searchParams.get('lang') === 'en' ? 'en' : 'fr';

  const setLang = React.useCallback((newLang) => {
    if (newLang === 'fr') {
      searchParams.delete('lang');
    } else {
      searchParams.set('lang', newLang);
    }
    setSearchParams(searchParams, { replace: true });
  }, [searchParams, setSearchParams]);

  const value = useMemo(() => ({ lang, setLang }), [lang, setLang]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
